import React from 'react';
import "./index.css";

export default ({ size }) => {
    return (
        <div className="loader" style={{ width: size, height: size}}></div>
    )
}
